import { GameCard2, GameCard2Props } from './cards/GameCard2';
import { ItemCardPriced, ItemCardPricedProps } from './cards/ItemCardPriced';
import { CollectionCard, CollectionCardProps } from './cards/CollectionCard';
import Box from '@mui/material/Box';
import { GradientTypography } from './gradients/GradientTypography';
import { useMobile } from 'src/hooks/useMobile';
import { ReactGlider } from './ReactGlider';
import Stack from '@mui/material/Stack';
import { getItemKey } from 'functions/src/util/items/getItemKey';
import { useTheme } from '@mui/material/styles';
import { useRef } from 'react';

export type HomepageCarouselProps = {
  content: GameCard2Props[] | ItemCardPricedProps[] | CollectionCardProps[];
  title: string;
  type: 'games' | 'listings' | 'collections' | 'onSale' | 'rentals';
};

export function HomepageCarousel({
  content,
  title,
  type,
}: HomepageCarouselProps) {
  const ref = useRef<Element | undefined>(undefined);

  const isMobile = useMobile();
  const theme = useTheme();
  return (
    <Box
      sx={{
        mb: 8,
        mt: 4,
      }}
    >
      <Stack
        direction="column"
        spacing={4}
        position="relative"
        sx={{ ml: isMobile ? 6 : 0, zIndex: theme.zIndex.glider }}
      >
        <GradientTypography
          variant="h4"
          gradientColor="primary.vertical"
          sx={{ textTransform: 'uppercase', mb: -2 }}
        >
          {title}
        </GradientTypography>
        <Box
          sx={{
            '& .glider-track': {
              width: `${
                type === 'games' ? 550 * content.length : 266 * content.length
              }px !important`,
            },
          }}
          ref={ref}
        >
          <ReactGlider
            itemWidth={type === 'games' ? 538 : 254}
            hasArrows={!isMobile}
            navGradientColor={'primary.verticalInverse'}
            sxIconLeft={{ marginLeft: '-48px' }}
            formatContainer={true}
          >
            {content &&
              content.map((item, index) => {
                return (
                  <Box
                    key={`slide-${getItemKey(item.contract)}-${index}`}
                    pr={index === content.length - 1 ? '50px' : '0px'}
                  >
                    {type === 'games' && (
                      <GameCard2
                        {...item}
                        root={ref.current?.querySelector('.glider-container')}
                      />
                    )}
                    {type === 'rentals' && (
                      <ItemCardPriced
                        {...item}
                        root={ref.current?.querySelector('.glider-container')}
                      />
                    )}
                    {(type === 'listings' || type === 'onSale') && (
                      <ItemCardPriced
                        {...item}
                        root={ref.current?.querySelector('.glider-container')}
                      />
                    )}
                    {type === 'collections' && (
                      <CollectionCard
                        {...item}
                        root={ref.current?.querySelector('.glider-container')}
                      />
                    )}
                  </Box>
                );
              })}
          </ReactGlider>
        </Box>
      </Stack>
    </Box>
  );
}
